<template><div><p class="d-docsite--paragraph"><code v-pre>DtLazyShow</code> is essentially a combination of a <code v-pre>v-if</code> and <code v-pre>v-show</code>. This means that the child slot will not be rendered/initialized until the first time <code v-pre>show</code> is <code v-pre>true</code>, after which the slot will stay in the DOM and be hidden/shown with the <code v-pre>v-show</code> directive. This is useful to prevent elements which are hidden from being rendered immediately, but keeping them alive when toggled later.</p>
<p class="d-docsite--paragraph">The lazy show wraps the slot in a parent <code v-pre>div</code> in order to achieve this. It also wraps the <code v-pre>v-show</code> in a <code v-pre>transition</code>, so you can pass any valid Vue transition class to control the enter/leave transitions.</p>
<code-well-header>
  <dt-button @click="isShown = !isShown">
    Toggle
  </dt-button>
  <dt-lazy-show
    transition="fade"
    :show="isShown"
  >
    I'm Lazy!
  </dt-lazy-show>
</code-well-header>
<code-example-tabs
htmlCode='
<button class="base-button__button d-btn d-btn--primary" type="button">
  <span class="d-btn__label base-button__label">
    Toggle
  </span>
</button>
<div>
  Im Lazy!
</div>
'
vueCode='
<dt-button @click="isShown = !isShown">
  Toggle
</dt-button>
<dt-lazy-show
  transition="fade"
  :show="isShown"
>
  Im Lazy!
</dt-lazy-show>
'
showHtmlWarning />
<h2 id="vue-api" tabindex="-1" class="d-docsite--header-2">Vue API <a class="header-anchor d-link d-docsite--link d-link" href="#vue-api" aria-hidden="true">#</a></h2>
<component-vue-api component-name="lazyshow" /></div></template>

<script>
export default {
  data() {
    return {
      isShown: false,
    }
  },
}
</script>
